export const BRAND = {
  primary: "#1E3048",
  canvas: "#141C2A",
  accent: "#C9A227",
  spotlight: "#2E7D6F",
  error: "#C23B22",
  font: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
};

/** Returns '#fff' or '#000' depending on which has better contrast wiþ `hex`. */
export const contrastText = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  // Relative luminance (sRGB coefficients)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000' : '#fff';
};

export const getThemeColors = (theme) => theme === 'dark' ? {
  background: BRAND.canvas,
  cardBg: '#121416',
  text: '#ffffff',
  textSecondary: '#e6eef7',
  textMuted: '#9aa4ad',
  inputBg: '#111315',
  borderColor: 'rgba(255,255,255,0.05)',
  buttonBg: BRAND.accent,
  buttonText: '#000',
  primary: "#2C4F72",
  buttonInactive: '#374357',
} : {
  background: '#f0f2f5',
  cardBg: '#ffffff',
  text: '#1a1d23',
  textSecondary: '#2c3e50',
  textMuted: '#6c757d',
  inputBg: '#f8f9fa',
  borderColor: 'rgba(0,0,0,0.1)',
  buttonBg: BRAND.accent,
  buttonText: '#000',
  primary: BRAND.primary,
  buttonInactive: '#D8DADE',
};

export const scrollbarStyles = `
  .custom-scrollbar::-webkit-scrollbar {
    width: 8px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(150,150,150,0.4);
    border-radius: 4px;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: rgba(150,150,150,0.6);
  }
`;

export const spinnerKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const autofillStyles = (theme) => `
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px ${theme === 'dark' ? '#111315' : '#f8f9fa'} inset !important;
    -webkit-text-fill-color: ${theme === 'dark' ? '#ffffff' : '#1a1d23'} !important;
  }
`;

export const inputStyle = (themeColors) => ({
  padding: '10px 12px',
  borderRadius: 8,
  background: themeColors.inputBg,
  color: themeColors.text,
  border: `1px solid ${themeColors.borderColor}`,
  width: '100%',
  boxSizing: 'border-box',
  fontFamily: BRAND.font,
  fontSize: 16,
});

export const cardStyle = (themeColors) => ({
  background: themeColors.cardBg,
  borderRadius: 8,
  padding: 16,
  boxShadow: themeColors.cardBg === '#ffffff'
    ? '0 2px 8px rgba(0,0,0,0.1)'
    : '0 6px 18px rgba(0,0,0,0.5)',
  border: `1px solid ${themeColors.borderColor}`,
});

export const sectionHeaderStyle = (themeColors) => ({
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 'bold',
  color: themeColors.text,
});

export const sendBtnStyle = {
  padding: '10px 14px',
  borderRadius: 8,
  background: BRAND.accent,
  border: 'none',
  cursor: 'pointer',
  color: contrastText(BRAND.accent),
  fontWeight: 'normal',
};

